import { api } from "../../apiendpoints/index";
import axios from "../../axiosMiddleware";

// Organization
export const GetOrganization = async () => {
  return await axios.get(`${api.ADMIN.ORGANIZATION}`, { mode: "cors" });
};

// Add or Edit Employee
export const AddOrEditEmployee = async (formData) => {
  return axios.post(`${api.ADMIN.ADD_EDIT_EMPLOYEE}`, formData);
};

// Workload Assignments
export const GetWorkloadAssignments = async (department) => {
  return await axios.get(`${api.DASHBOARD.GET_WORKLOAD_ASSIGNMENTS}?department=${department}`);
};

export const SaveWorkloadAssignments = async (formData) => {
  return axios.post(`${api.DASHBOARD.SAVE_WORKLOAD_ASSIGNMENTS}`, formData);
};

//Change Employee Status
export const ChangeEmployeeStatus = async (formData) => {
  return axios.post(`${api.ADMIN.CHANGE_EMPLOYEE_STATUS}`, formData);
};

export const ChangeEmployeDepartment = async (formData) => {
  return axios.post(`${api.ADMIN.CHANGE_EMP_DEPARTMENT}`, formData);
};
// Add Employee From Excel
export const AddBulkEmployee = async (formData) => {
  return axios.post(`${api.ADMIN.ADD_BULK_EMPLOYEE}`, formData, { responseType: 'blob' });
};

export const SampleFileDownload = async () => {
  return axios.get(`${api.ADMIN.SAMPLE_FILE_DOWNLOAD}`);
};

//Job Description
export const GetJobDescription = async () => {
  return await axios.get(`${api.ADMIN.JOB_DESCRIPTION}`);
};

//New Job Description
export const GetJobDescriptionnew = async () => {
  return await axios.get(`${api.ADMIN.GET_ROLES}`);
};

// Reporting Under
export const GetReportingUser = async () => {
  return await axios.get(`${api.ADMIN.REPORTING_USER}`);
};

export const GetAllEmployeeTypes = async () => {
  return await axios.get(`${api.ADMIN.GET_ALL_EMPLOYEE_TYPE}`);
};

//Manager
export const GetManager = async () => {
  return await axios.get(`${api.ADMIN.MANAGER_USER}`);
};

//Training
export const GetTrainingList = async () => {
  return await axios.get(`${api.ADMIN.TRAININGLIST}`);
};
//Department
export const GetDepartment = async (user) => {
  return axios.get(`${api.ADMIN.DEPARTMENT}?DepartmentSupervisorName=${user}`);
};

export const GetAllDepartments = async () => {
  return axios.get(`${api.ADMIN.MASTER_DEPARTMENT}`);
};
export const GetDesignation = async (selectedDept) => {
  return axios.get(`${api.ADMIN.MASTER_DESIGNATION}?DepartmentId=${selectedDept}`);
};
export const GetEmployeeById = async (employeeId) => {
  return axios.get(`${api.ADMIN.GET_EMPLOYEE_BYID}?EmployeeId=${employeeId}`);
};

// GetAllEmployeeDropDown
export const GetEmployeeDropDown = async () => {
  return axios.get(`${api.ADMIN.GET_ALL_EMPLOYEE_DROPDOWN}`);
};
// export const GetEmployeeDropDown = async () => {
//   try {
//     const response = await axios.get(
//       api.ADMIN.GET_ALL_EMPLOYEE_DROPDOWN
//     );

//     return response.data;
//   } catch (error) {
//     console.log("GET EMPLOYEE DROPDOWN API ERROR =>", error);

//     throw error;
//   }
// };
// GetAllEmployeeDropDown
export const SendEvalutionForm = async (formData) => {
  return axios.post(`${api.HUMAN_RESOURCE.SENDEVALUTIONFORM}`, formData);
};
export const TrainingStatus = async (formData) => {

  return axios.post(`${api.ADMIN.SAVE_TRAINING_DETAILS}`, formData);

};
export const DownloadEmployeePdf = async (EmployeeId) => {

  return axios.get(`${api.ADMIN.DOWNLOAD_PDF_ADD_EMPLOYEE}?EmployeeId=${EmployeeId}`);

};

//GetHoliday
export const GetHoliday = async () => {
  return axios.get(`${api.ADMIN.MASTER_DEPARTMENT}`);
};
 


// POST API FOR ADD EMPLOYEE
// export const AddEmployee = async (data) => {
//   const formData = new FormData();
//   formData.append("Id", data.id)
//   formData.append("PersonID", data.employeeId);
//   formData.append("FirstName", data.firstName);
//   formData.append("LastName", data.lastName);
//   formData.append("Organization", data.organization);
//   formData.append("Department", data.department);
//   formData.append("EmpPosition", data.empPosition);
//   formData.append("ReportingUnder", data.reportingUnder);
//   formData.append("DOB", data.dob);
//   formData.append("Gender", data.gender);
//   formData.append("Address1", data.address1);
//   formData.append("Address2", data.address2);
//   formData.append("EmailAddress", data.emailAddress);
//   formData.append("BloodGroup", data.bloodGroup);
//   formData.append("DOJ", data.doj);
//   formData.append("AvatarImage", data.avatarImage);
//   formData.append("SignatureImage", data.signatureImage);
//   formData.append("PhoneNo", data.phoneNo);
//   formData.append("Role", data.roleId);

//   return axios.post(`${api.ADMIN.ADD_EMPLOYEE}`, formData);
// };

// Check If EmployeeID already exists
export const GetExistEmployee = async (id) => {
  return axios.get(`${api.ADMIN.CHECK_EMPLOYEE_EXIST}?EmployeeId=${id}`);
};

export const GetExistEmail = async (eid) => {
  return axios.get(`${api.ADMIN.CHECK_EMAIL_EXIST}?EmailAddress=${eid}`);
};

//GET API for employee limit
export const GetLimit = async () => {
  return await axios.get(`${api.ADMIN.EMPLOYEE_LIMIT}`);
};
export const GetOfficeEmployee = async () => {
  return await axios.get(`${api.ADMIN.OFFICE_EMPLOYEE}`);
};

//GET API for employee limit
export const GetEmployeeDetails = async (value) => {
  return await axios.get(`${api.ADMIN.EMPLOYEE_DETAIL}?EmployeeId=${value}`);
};

//GET api for search limit
export const GetSearch = async (value) => {
  return await axios.get(`${api.ADMIN.EMPLOYEE_LIMIT}?SearchKeyword=${value}`);
};

// Sorting data
export const GetSort = async (value, dir) => {
  return await axios.get(
    `${api.ADMIN.EMPLOYEE_LIMIT}?SortExpression=${value}%20${dir}`
  );
};

// POST API for update employee limit
export const UpdateLimit = async (data) => {
  // const data = { limitId: id, limit: limit };
  return axios.post(`${api.ADMIN.UPDATE_LIMIT}`, data);
};

// POST API for changing employee status
export const ChangeStatus = async (data) => {
  return axios.post(`${api.ADMIN.CHANGE_STATUS}`, data);
};

//Get Document Approval List
export const GetDocumentList = async (data) => {
  return await axios.post(`${api.ADMIN.DOCUMENT_APPROVAL}`, data);
};

// Update Document List
export const UpdateDocumentList = async (data) => {
  return axios.post(`${api.ADMIN.UPDATE_APPROVAL_LIST}`, data);
};

// Update Document List
export const GetUserRolesRights = async () => {
  return axios.get(`${api.ADMIN.GET_USER_ROLES_RIGHTS}`);
};

//Get Employee Position
export const GetPosition = async () => {
  return axios.get(`${api.ADMIN.GET_POSITION}`);
};


export const GetRoles = async () => {
  return axios.get(`${api.ADMIN.GET_ROLES}`);
};

export const GetRightsById = async ({ roleId = null, userId = null, departmentid = null }) => {
  let params = {};

  if (roleId) {
    params.RoleId = roleId;
  } else if (userId) {
    params.UserId = userId;
  } else if (departmentid) {
    params.departmentid = departmentid;
  }

  return axios.get(api.ADMIN.GET_RIGHTS_BY_ID, { params });
};

export const UpdateRightsById = async (data) => {
  return axios.post(`${api.ADMIN.UPDATE_RIGHTS_BY_ID}`, data);
};

export const UpdateUserRightsById = (data) => {
  return axios.post(
    api.ADMIN.UPDATE_USER_RIGHTS_BY_ID,
    data
  );
};

export const GetUserRightsById = async (params) => {
  return axios.get(
    api.ADMIN.GET_USER_RIGHTS_BY_ID,
    { params }
  );
};

export const AddDepartment = (data) => {
  return axios.post(api.ADMIN.AddOrEditOrDeleteDepartment, {
    Action: "INSERT",
    ...data,
  });
};

export const UpdateDepartment = (data) => {
  return axios.post(api.ADMIN.AddOrEditOrDeleteDepartment, {
    Action: "UPDATE",
    ...data,
  });
};

export const DeleteDepartment = (id) => {
  return axios.post(api.ADMIN.AddOrEditOrDeleteDepartment, {
    Action: "DELETE",
    Id: id,
  });
};

export const getResponsibilityMatrix = async (departmentId = 7) => {
  return await axios.get(`${api.ADMIN.GET_RESPONSIBILITY_MATRIX}?departmentId=${departmentId}`);
};

export const addResponsibilityMatrix = async (data) => {
  return await axios.post(api.ADMIN.ADD_RESPONSIBILITY_MATRIX, data);
};

export const AddTraining = (data) => {
  return axios.post(api.ADMIN.AddOrEditOrDeleteTraining, {
    Action: "INSERT",
    RoleId: 1,
    ...data,
  });
};

export const UpdateTraining = (data) => {
  return axios.post(api.ADMIN.AddOrEditOrDeleteTraining, {
    Action: "UPDATE",
    ...data,
  });
};

export const DeleteTraining = (id) => {
  return axios.post(api.ADMIN.AddOrEditOrDeleteTraining, {
    Action: "DELETE",
    Id: id,
  });
};

export const AddDesignation = (data) => {
  return axios.post(api.ADMIN.AddOrEditOrDeleteDesignation, {
    Action: "INSERT",
    RoleId: 1,
    IsActive: true,
    ...data,
  });
};

export const UpdateDesignation = (data) => {
  return axios.post(api.ADMIN.AddOrEditOrDeleteDesignation, {
    Action: "UPDATE",
    ...data,
  });
};

export const DeleteDesignation = (id) => {
  return axios.post(api.ADMIN.AddOrEditOrDeleteDesignation, {
    Action: "DELETE",
    Id: id,
  });
};

export const GetDesignationList = () => {
  return axios.post(api.ADMIN.AddOrEditOrDeleteDesignation, {
    Action: "GET",
  });
};

export const GetDesignationByDepartmentIdApi = (departmentId) => {
  return axios.get(api.ADMIN.GetDesignationByDepartmentId, {
    params: {
      DepartmentId: departmentId,
    },
  });
};

export const GetApplicationList = () => {
  return axios.post(api.ADMIN.AddOrEditOrDeleteApplication, {
    Action: "GET",
  });
};
export const GetApplicationEmployees = () => {
  return axios.post(api.ADMIN.AddOrEditOrDeleteApplication, {
    Action: "GET_EMPLOYEE",
  });
};

export const AddApplication = (data) => {
  return axios.post(api.ADMIN.AddOrEditOrDeleteApplication, {
    Action: "INSERT",
    IsActive: true,
    ...data,
  });
};


export const UpdateApplication = (data) => {
  return axios.post(api.ADMIN.AddOrEditOrDeleteApplication, {
    Action: "UPDATE",
    ...data,
  });
};

export const DeleteApplication = (id) => {
  return axios.post(api.ADMIN.AddOrEditOrDeleteApplication, {
    Action: "DELETE",
    Application_ID: id,
  });
};

export const GetApplicationsModulesList = () => {
  return axios.post(
    api.ADMIN.AddOrEditOrDeleteApplicationModules,
    {
      Action: "GET",
    }
  );
};

export const AddApplicationsModules = (data) => {
  return axios.post(
    api.ADMIN.AddOrEditOrDeleteApplicationModules,
    {
      Action: "INSERT",
      IsActive: true,
      ...data,
    }
  );
};

export const UpdateApplicationsModules = (data) => {
  return axios.post(
    api.ADMIN.AddOrEditOrDeleteApplicationModules,
    {
      Action: "UPDATE",
      ...data,
    }
  );
};

export const DeleteApplicationsModules = (id) => {
  return axios.post(
    api.ADMIN.AddOrEditOrDeleteApplicationModules,
    {
      Action: "DELETE",
      Module_ID: id,
    }
  );
};
export const GetApplicationsSubModulesList = () => {
  return axios.post(
    api.ADMIN.AddOrEditOrDeleteApplicationsSubModules,
    {
      Action: "GET",
    }
  );
};

export const AddApplicationsSubModules = (data) => {
  return axios.post(
    api.ADMIN.AddOrEditOrDeleteApplicationsSubModules,
    {
      Action: "INSERT",
      IsActive: true,
      ...data,
    }
  );
};

export const UpdateApplicationsSubModules = (data) => {
  return axios.post(
    api.ADMIN.AddOrEditOrDeleteApplicationsSubModules,
    {
      Action: "UPDATE",
      ...data,
    }
  );
};

export const DeleteApplicationsSubModules = (id) => {
  return axios.post(
    api.ADMIN.AddOrEditOrDeleteApplicationsSubModules,
    {
      Action: "DELETE",
      Sub_Module_ID: id,
    }
  );
};
export const AddRequestType = (data) => {
  return axios.post(api.ADMIN.AddOrEditOrDeleteRequestType, {
    Action: "INSERT",
    IsActive: true,
    ...data,
  });
};

export const UpdateRequestType = (data) => {
  return axios.post(api.ADMIN.AddOrEditOrDeleteRequestType, {
    Action: "UPDATE",
    ...data,
  });
};

export const DeleteRequestType = (id) => {
  return axios.post(api.ADMIN.AddOrEditOrDeleteRequestType, {
    Action: "DELETE",
    Id: id,
  });
};

export const GetRequestTypeList = () => {
  return axios.post(api.ADMIN.AddOrEditOrDeleteRequestType, {
    Action: "GET",
  });
};

export const GetDashboardModulesList = () => {
  return axios.post(
    api.ADMIN.AddOrEditOrDeleteDashboardModules,
    {
      Action: "GET",
    }
  );
};

export const AddDashboardModules = (data) => {
  return axios.post(
    api.ADMIN.AddOrEditOrDeleteDashboardModules,
    {
      Action: "INSERT",
      IsActive: true,
      ...data,
    }
  );
};

export const UpdateDashboardModules = (data) => {
  return axios.post(
    api.ADMIN.AddOrEditOrDeleteDashboardModules,
    {
      Action: "UPDATE",
      ...data,
    }
  );
};

export const DeleteDashboardModules = (id) => {
  return axios.post(
    api.ADMIN.AddOrEditOrDeleteDashboardModules,
    {
      Action: "DELETE",
      ModuleID: id,
    }
  );
};

export const GetDashboardModulePagesList = () => {
  return axios.post(
    api.ADMIN.AddOrEditOrDeleteDashboardModulePages,
    {
      Action: "GET",
    }
  );
};
export const AddDashboardModulePages = (data) => {
  return axios.post(
    api.ADMIN.AddOrEditOrDeleteDashboardModulePages,
    {
      Action: "INSERT",
      IsActive: true,
      ...data,
    }
  );
};

export const UpdateDashboardModulePages = (data) => {
  return axios.post(
    api.ADMIN.AddOrEditOrDeleteDashboardModulePages,
    {
      Action: "UPDATE",
      ...data,
    }
  );
};

export const DeleteDashboardModulePages = (id) => {
  return axios.post(
    api.ADMIN.AddOrEditOrDeleteDashboardModulePages,
    {
      Action: "DELETE",
      PageID: id,
    }
  );
};

export const GetDefaultPagesAccessList = () => {
  return axios.post(
    api.ADMIN.AddOrEditOrDeleteDefaultPagesAccess,
    {
      Action: "GET",
    }
  );
};

export const AddDefaultPagesAccess = (data) => {
  return axios.post(
    api.ADMIN.AddOrEditOrDeleteDefaultPagesAccess,
    {
      Action: "INSERT",
      IsActive: true,
      ...data,
    }
  );
};

export const UpdateDefaultPagesAccess = (data) => {
  return axios.post(
    api.ADMIN.AddOrEditOrDeleteDefaultPagesAccess,
    {
      Action: "UPDATE",
      ...data,
    }
  );
};

export const DeleteDefaultPagesAccess = (id) => {
  return axios.post(
    api.ADMIN.AddOrEditOrDeleteDefaultPagesAccess,
    {
      Action: "DELETE",
      Id: id,
    }
  );
}

export const GetPendingEmployeeApprovals = async (data = {}) => {
  const payload = {
    data: {
      approvalStatus: 0,
    },
    start: 0,
    length: 1000,
    sortExpression: "CreatedDate desc",
    searchKeyword: null,
    searchFilterJson: null,
  };

  return axios.post(api.ADMIN.GET_PENDING_EMPLOYEE_APPROVALS, payload);
};

export const ApproveOrRejectEmployee = async (data) => {
  return axios.post(api.ADMIN.APPROVE_OR_REJECT_EMPLOYEE, data);
};

export const AddDatabaseMaster = (data) => {
  return axios.post(
    api.ADMIN.AddOrEditOrDeleteDatabaseMaster,
    {
      Action: "INSERT",
      IsActive: true,
      ...data,
    }
  );
};

export const UpdateDatabaseMaster = (data) => {
  return axios.post(
    api.ADMIN.AddOrEditOrDeleteDatabaseMaster,
    {
      Action: "UPDATE",
      ...data,
    }
  );
};

export const DeleteDatabaseMaster = ({
  tableId = null,
  storedProcedureId = null,
}) => {
  return axios.post(
    api.ADMIN.AddOrEditOrDeleteDatabaseMaster,
    {
      Action: "DELETE",
      Table_ID: tableId,
      Stored_Procedure_ID: storedProcedureId,
      IsActive: false,
    }
  );
};

export const GetDatabaseMasterList = (
  filters = {}
) => {
  return axios.post(
    api.ADMIN.AddOrEditOrDeleteDatabaseMaster,
    {
      Action: "GET",

      Database_Name:
        filters.databaseName || null,

      Schema_Name:
        filters.schemaName || null,

      Application_ID:
        filters.applicationId || null,

      Module_ID:
        filters.moduleId || null,

      Sub_Module_ID:
        filters.subModuleId || null,

      RecordType:
        filters.recordType || null,

      SearchKeyword:
        filters.searchKeyword || null,
    }
  );
};

/*----------------------------------------------------------------------------------------------*/
// Application Version Management
export const AddOrEditApplicationVersion = (payload) => {
  return axios.post(
    api.ADMIN.ADD_OR_EDIT_APPLICATION_VERSION,
    payload,
  );
};

export const GetApplicationVersionList = (payload) => {
  return axios.post(
    api.ADMIN.GET_APPLICATION_VERSION_LIST,
    payload,
  );
};

export const GetApplicationVersionById = (payload) => {
  return axios.post(
    api.ADMIN.GET_APPLICATION_VERSION_BY_ID,
    payload,
  );
};

export const DeleteApplicationVersion = (payload) => {
  return axios.post(
    api.ADMIN.DELETE_APPLICATION_VERSION,
    payload,
  );
};

export const GetLatestApplicationVersion = async (applicationId = 1) => {
  return axios.get(
    api.ADMIN.GET_LATEST_APPLICATION_VERSION,
    {
      params: {
        applicationId
      }
    }
  );
};
/*------------------------------------------------------------------------------------------------*/

// DB-backed dynamic EPO workflow configuration
export const getEpoWorkflowConfiguration = () =>
  axios.get(api.ADMIN.GET_EPO_WORKFLOW_CONFIGURATION);

export const saveEpoWorkflowRule = (payload) =>
  axios.post(api.ADMIN.SaveEpoWorkflowRule, payload);

export const saveEpoWorkflowSteps = (payload) =>
  axios.post(api.ADMIN.SaveEpoWorkflowSteps, payload);

export const saveEpoAuthority = (payload) =>
  axios.post(api.ADMIN.SaveEpoAuthority, payload);

// Dynamic EPO workflow validation + read-only backend simulator
export const validateEpoWorkflowConfiguration = () =>
  axios.get(api.ADMIN.ValidateEpoWorkflowConfiguration);

export const simulateEpoWorkflow = (payload) =>
  axios.post(api.ADMIN.SimulateEpoWorkflow, payload);

/*-------------------------------------------------------------
  Dynamic EPO Email Template
  One API -> master.EpoMailTemplate_Execute
-------------------------------------------------------------*/

export const executeEpoMailTemplate = (payload) =>
  axios.post(api.ADMIN.EpoMailTemplate, payload);

export const getEpoMailTemplates = () =>
  executeEpoMailTemplate({
    action: "GET_ALL",
  });

export const getEpoMailTemplateById = (id) =>
  executeEpoMailTemplate({
    action: "GET_BY_ID",
    id,
  });

export const saveEpoMailTemplate = (payload) =>
  executeEpoMailTemplate({
    action: "SAVE",
    ...payload,
  });

export const setEpoMailTemplateActive = (id, isActive) =>
  executeEpoMailTemplate({
    action: "SET_ACTIVE",
    id,
    isActive,
  });

export const setEpoMailTestMode = ({
  isTestMode,
  testToEmails,
  testCcEmails = null,
  testBccEmails = null,
}) =>
  executeEpoMailTemplate({
    action: "SET_TEST_MODE",
    isTestMode,
    testToEmails,
    testCcEmails,
    testBccEmails,
  });

export const resolveEpoMailTemplate = ({
  eventCode,
  workflowRuleCode = null,
  workflowStepCode = null,
}) =>
  executeEpoMailTemplate({
    action: "RESOLVE",
    eventCode,
    workflowRuleCode,
    workflowStepCode,
  });

export const BulkActivateEpoWorkflowRules = (payload) =>
  axios.post(api.ADMIN.BulkActivateEpoWorkflowRules, payload);

export const executeEpoMailToken = (payload) =>
  axios.post(api.ADMIN.EpoMailToken, payload);

export const getEpoMailTokens = () =>
  executeEpoMailToken({
    action: "GET_ALL",
    isActive: true,
  });

export const saveEpoMailToken = (data) =>
  executeEpoMailToken({
    action: "SAVE",
    id: data?.id ?? null,
    tokenKey: data?.tokenKey ?? "",
    displayName: data?.displayName ?? "",
    description: data?.description ?? "",
    category: data?.category ?? "",
    sourceType: data?.sourceType ?? "",
    sourceKey: data?.sourceKey ?? "",
    formatType: data?.formatType ?? "TEXT",
    sortOrder: data?.sortOrder ?? 100,
    isActive: data?.isActive ?? true,
  });

export const setEpoMailTokenActive = (id, isActive) =>
  executeEpoMailToken({
    action: "SET_ACTIVE",
    id,
    isActive,
  });

  export const getEpoMailTokenSourceFields = () =>
  axios.get(api.ADMIN.GET_EPO_MAIL_TOKEN_SOURCE_FIELDS);